module.exports = __webpack_public_path__ + "img/cloth_g1_pants_05.060bba51.svg";